// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.config {\n  font-weight: 700;\n  color: #72737A;\n}\n", ""]);
// Exports
module.exports = exports;
